import { render, staticRenderFns } from "./index-coworking.vue?vue&type=template&id=1019aa1c&"
import script from "./index-coworking.vue?vue&type=script&lang=js&"
export * from "./index-coworking.vue?vue&type=script&lang=js&"
import style0 from "./index-coworking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports